import React from 'react'

import { PresetConfigLoader } from '../../../views/Setup/AIFeaturePresets/PresetConfig/Common/PresetConfigLoader'

import { selectSafeAuthenticatedUser } from '../../../store/auth/authSlice'
import { useAppSelector } from '../../../store/hooks'

import { DocumentTypeInputParametersHierarchyConfigComponentProps } from '../model'

import { useDocumentTypeEffectiveInputParameters } from '../hooks'

import { CurrentUserConfigFormBody } from './CurrentUserConfigFormBody'

export const DocumentTypeCurrentUserTemplateInputParameterConfigForm: React.FC<DocumentTypeInputParametersHierarchyConfigComponentProps> = ({
  type,
  typeId,
  inputParametersSchema,
  defaultInputParameters,
  documentTypeId,
  showCustomizationSetting,
  onHide,
  ipHierarchyEnabled,
}) => {
  const { id: currentUserId } = useAppSelector(selectSafeAuthenticatedUser)
  const { inputParameters, parentInputParameters, updateLoading, updateInputParameters, isCustomized } = useDocumentTypeEffectiveInputParameters(
    type,
    typeId,
    defaultInputParameters,
    currentUserId,
    documentTypeId,
  )

  if (!inputParameters || !parentInputParameters) {
    return <PresetConfigLoader />
  }

  return (
    <CurrentUserConfigFormBody
      type={type}
      typeId={typeId}
      inputParametersSchema={inputParametersSchema}
      inputParameters={{ example_1: '', example_2: '', template: inputParameters.template }}
      defaultInputParameters={{ example_1: '', example_2: '', template: defaultInputParameters?.template ?? '' }}
      parentInputParameters={{ example_1: '', example_2: '', template: parentInputParameters.template }}
      isCustomized={isCustomized}
      showCustomizationSetting={showCustomizationSetting}
      onSave={updateInputParameters}
      onHide={onHide}
      updateLoading={updateLoading}
      ipHierarchyEnabled={ipHierarchyEnabled}
    />
  )
}
